import React, { useEffect, useState } from "react";
import { Table, Card, Button, Input, Space, Row, Col, Typography, message, Modal, Tag } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, ReloadOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import axiosInstance from "../../../configs";
import { canDelete, MODULES } from "../../../utils/rbac";

const { Title, Text } = Typography;
const { Search } = Input;

export default function ContactList() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get("/contact", {
                params: { name: search }
            });
            setData(res.data || []);
        } catch (err) {
            console.error(err);
            message.error("Gagal mengambil data kontak");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [search]);

    const handleDelete = (id) => {
        Modal.confirm({
            title: "Hapus Kontak?",
            content: "Data yang dihapus tidak dapat dikembalikan.",
            okText: "Ya, Hapus",
            okType: "danger",
            onOk: async () => {
                try {
                    await axiosInstance.delete(`/contact/${id}`);
                    message.success("Kontak berhasil dihapus");
                    fetchData();
                } catch (e) {
                    message.error(e.response?.data?.error || "Gagal menghapus kontak");
                }
            }
        });
    };

    const columns = [
        {
            title: "Kode",
            dataIndex: "id_kode_perusahaan",
            key: "id_kode_perusahaan",
            width: 80,
            render: (text) => text && text !== '-' ? <Tag color="purple">{text}</Tag> : <Text type="secondary">-</Text>
        },
        {
            title: "Nama",
            dataIndex: "name",
            key: "name",
            render: (text) => <Text strong>{text}</Text>
        },
        {
            title: "Status Grup",
            dataIndex: "contact_type",
            key: "contact_type",
            width: 150,
            render: (val) => {
                // 0: Grup (special pricing), 1: Non-Grup (regular pricing)
                if (val === 0) return <Tag color="green">Grup (Harga Khusus)</Tag>;
                if (val === 1) return <Tag color="blue">Non-Grup (Reguler)</Tag>;
                return <Tag>{val}</Tag>;
            }
        },
        {
            title: "Alamat",
            dataIndex: "address",
            key: "address",
            ellipsis: true
        },
        {
            title: "Email / Telepon",
            key: "contact",
            render: (_, r) => (
                <div>
                    {r.email && <div>{r.email}</div>}
                    {r.phone && <Text type="secondary">{r.phone}</Text>}
                </div>
            )
        },
        {
            title: "Aksi",
            key: "action",
            width: 120,
            align: "center",
            render: (_, r) => (
                <Space>
                    <Link to={`/referensi/kontak/edit/${r.id_contact}`}>
                        <Button icon={<EditOutlined />} size="small" type="primary" />
                    </Link>
                    {canDelete(MODULES.REFERENSI) && (
                        <Button
                            icon={<DeleteOutlined />}
                            size="small"
                            danger
                            onClick={() => handleDelete(r.id_contact)}
                        />
                    )}
                </Space>
            )
        }
    ];

    return (
        <Card>
            <Row justify="space-between" style={{ marginBottom: 20 }}>
                <Col>
                    <Title level={4}>Daftar Pemasok / Pemilik</Title>
                </Col>
                <Col>
                    <Space>
                        <Button icon={<ReloadOutlined />} onClick={fetchData}>Refresh</Button>
                        <Link to="/referensi/kontak/create">
                            <Button type="primary" icon={<PlusOutlined />}>Tambah Baru</Button>
                        </Link>
                    </Space>
                </Col>
            </Row>

            <Row style={{ marginBottom: 16 }}>
                <Col span={8}>
                    <Search
                        placeholder="Cari nama..."
                        onSearch={val => setSearch(val)}
                        allowClear
                        enterButton
                    />
                </Col>
            </Row>

            <Table
                dataSource={data}
                columns={columns}
                rowKey="id_contact"
                loading={loading}
                pagination={{ pageSize: 20 }}
                scroll={{ x: 'max-content' }}
            />
        </Card>
    );
}

